// 初始化项目的时候填入的变量, 请谨慎修改, 会影响各个地方的使用
export const componentName = 'OperateComponents';
export const libraryName = 'operate-components';
